<div class="d-flex align-items-center my-3 px-1">
  <mat-slide-toggle class="custom-slider" (ngModelChange)="update($event)" *ngIf="ngModel !== null" [ngModel]="ngModel"><span class="ml-2 font-weight-bold">{{ name }}</span></mat-slide-toggle>

  <mat-slide-toggle class="custom-slider" *ngIf="ngModel === null" [ngModel]="defaultValue" disabled><span class="ml-2 font-weight-bold">{{ name }}</span></mat-slide-toggle>

  <button (click)="switchToDefault()" *ngIf="ngModel !== null && hasDefaultValue" class="ml-2" mat-button type="button">Use Default</button>

  <button (click)="update('true')" *ngIf="ngModel === null" class="ml-2" mat-button type="button"><i class="fa fa-edit"></i></button>
</div>
